<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <AdminTools></AdminTools>
            <ZoneList></ZoneList>
        </section>
    </div>
</template>

<script>
import AdminTools from "../../adminTools/Admin";
import ZoneList from "@/components/admin/zone/ZoneList";

export default {
    components: {
        ZoneList,
        AdminTools
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Zones.vue?2fd45ead